// extracted by mini-css-extract-plugin
export default {"setMachineTestsPanel":"TrainTestSplit_setMachineTestsPanel__O3F2Z","machineListPanel":"TrainTestSplit_machineListPanel__vr8od"};